import { createContext, useContext } from 'react';

export const ClientWorkspaceContext = createContext(null);
export const useClientWorkspace = () => useContext(ClientWorkspaceContext);
